/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryTemplateIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="72" height="72" rx="10.2835" fill="currentColor" fillOpacity="0.06" />
    <g clipPath="url(#clip0_1608_6666)">
      <path
        d="M33.2235 19.3805H20.7647C20.0038 19.3805 19.3805 20.0034 19.3805 20.7651V51.2199C19.3805 51.9807 20.0038 52.6041 20.7647 52.6041H33.2235C33.9847 52.6041 34.6081 51.9807 34.6081 51.2199V20.7651C34.6081 20.0034 33.9847 19.3805 33.2235 19.3805ZM31.8393 49.8353H22.1493V22.1489H31.8393V49.8353Z"
        fill="currentColor"
      />
      <path
        d="M51.2198 19.3805H38.7609C37.9997 19.3805 37.3763 20.0034 37.3763 20.7651V33.2239C37.3763 33.9847 37.9997 34.6077 38.7609 34.6077H51.2198C51.9806 34.6077 52.604 33.9847 52.604 33.2239V20.7651C52.604 20.0034 51.9806 19.3805 51.2198 19.3805ZM49.8352 31.8393H40.1451V22.1489H49.8352V31.8393Z"
        fill="currentColor"
      />
      <path
        d="M51.2198 37.3768H38.7609C37.9997 37.3768 37.3763 37.9998 37.3763 38.7606V51.2198C37.3763 51.9807 37.9997 52.604 38.7609 52.604H51.2198C51.9806 52.604 52.604 51.9807 52.604 51.2198V38.7606C52.604 37.9998 51.9806 37.3768 51.2198 37.3768ZM49.8352 49.8353H40.1451V40.1452H49.8352V49.8353Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1608_6666">
        <rect width="33.2236" height="33.2236" fill="white" transform="translate(19.3805 19.3805)" />
      </clipPath>
    </defs>
  </svg>
);
